import { serializeDate } from './serializeDate';

/**
 * Replaces a `Date` property on an object with the ISO 8601 string representation.
 *
 * Intended for use with `JSON.stringify`.
 *
 * @this Object Source object being serialized.
 *
 * @param {string} key - The key on the object.
 * @param {*} value - The pre-serialized value of the property.
 *
 * @returns {*} The ISO 8601 string representation if the property value is a date, otherwise `value`.
 *
 * @example
 * JSON.stringify({ date: new Date(2021, 0, 1) }, replaceDate);
 * // "{ "date": "2021-01-01T00:00:00.000-06:00" }"
 */
export function replaceDate (key, value) {
  // toJSON is called before the replacer so we must get the value
  // directly off the object instead of using the second parameter.
  const actualValue = this[key];
  return actualValue instanceof Date ? serializeDate(actualValue) : value;
}
